var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"bell",on:{"click":_vm.openNotification}},[_c('bell-icon')],1),_c('div',{ref:"container",class:("notifications " + (_vm.open ? 'open' : ''))},[_vm._v(" No notification ")])])}
var staticRenderFns = []

export { render, staticRenderFns }